// @flow

import { get, isEmpty } from 'lodash';

import { type AccountPlan, infinitize } from '@zapier/common-utils';

export default [
  {
    hasFeature: (plan: AccountPlan) =>
      Boolean(get(plan, 'can_autoreplay_errored_tasks')),
    helpText: 'What is this?',
    helpUrl: '/help/autoreplay',
    key: 'hasAutoReplay',
    name: 'Autoreplay',
  },
  {
    hasFeature: (plan: AccountPlan) =>
      Boolean(get(plan, 'allow_branching_zaps')),
    helpText: 'What is this?',
    helpUrl: '/help/paths',
    key: 'hasPaths',
    name: 'Paths',
  },
  {
    hasFeature: (plan: AccountPlan) =>
      !isEmpty(get(plan, 'metered_pricing_tiers')),
    helpText: 'What is this?',
    helpUrl: '/teams/#teams-pricing',
    key: 'hasMeteredBilling',
    name: 'Metered Billing',
  },
  {
    hasFeature: (plan: AccountPlan) =>
      Boolean(infinitize(get(plan, 'zap_length')) > 3),
    helpText: 'What are these?',
    helpUrl: '/learn/getting-started-guide/multi-step-zaps',
    key: 'hasMultiStepZaps',
    name: 'Multi-Step Zaps',
  },
  {
    hasFeature: (plan: AccountPlan) => Boolean(get(plan, 'allow_premium_apps')),
    helpText: 'View All Premium Apps',
    helpUrl: '/apps/categories/premium',
    key: 'hasPremiumApps',
    name: 'Premium Apps',
  },
  {
    hasFeature: (plan: AccountPlan) => Boolean(get(plan, 'allow_teams')),
    helpText: 'What is this?',
    helpUrl: '/help/team-accounts',
    key: 'hasTeams',
    name: 'Teams',
  },
];
